import React from "react";
import PropTypes from "prop-types";

import { Link } from 'react-router-dom';
import { push, replace } from "connected-react-router";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Email from "@material-ui/icons/Email";
import ArrowForward from "@material-ui/icons/ArrowForward";
import Sync from "@material-ui/icons/Sync";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import Api from "../../api/Api.js";
import { store } from "../../redux/store";
import { LOGIN_SUCCESS, SET_NOTIFICATIONS, OTP_REQUIRED, SET_OTP } from "../../redux/types";
import Loading from '../../components/Loading/Loading.jsx';
import AuthEndpoints from "../../api/AuthEndpoints";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";

class Login extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      username: '',
      usernameInvalid: false,
      password: '',
      passwordInvalid: false,
      loading: false
    };
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: "" }, () => {
          if (Api.isLoggedIn() && !Api.isLocked()) {
            store.dispatch(push('/dashboard'));
          }
        });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  verifyReCaptchaCallback = (recaptchaToken) => {
    console.log(recaptchaToken, "<= your recaptcha token")
  }

  submitLogin() {
    if (!this.state.username) {
      this.setState({ usernameInvalid: true, passwordInvalid: false });
      return;
    }
    if (!this.state.password) {
      this.setState({ usernameInvalid: false, passwordInvalid: true });
      return;
    }

    this.setState({ loading: true }, async () => {
      var recaptchaTimeout;

      const recaptcha_token = await Promise.race(
        [
          this.props.googleReCaptchaProps.executeRecaptcha('login'),
          new Promise((resolve, reject) => {
            recaptchaTimeout = setTimeout(() => {
              resolve(null);
            }, 1000);
          })
        ]
      );

      if (recaptchaTimeout)
        clearTimeout(recaptchaTimeout);

      Api.post(AuthEndpoints.doesRequireOtp, { ...{ username: this.state.username, password: this.state.password }, recaptcha_token }, 1, false)
        .then((response) => {

          let data;

          if (!response.data) {
            console.error("No Usable Data Received from Login Attempt");
            this.setState({ password: '', passwordInvalid: true, usernameInvalid: false, loading: false });
            return;
          } else {
            data = response.data;
          }

          if (data.mfa || data.sms || data.email) {
            store.dispatch({ type: SET_OTP, ...data });
            store.dispatch({ type: OTP_REQUIRED, payload: { username: this.state.username, password: this.state.password } });
            store.dispatch(push('/otp'));
          } else if (data.token) {
            Api.loggedIn(data.token, data.user.role.role1, data)
            store.dispatch({ type: LOGIN_SUCCESS, user: data.user });
            store.dispatch({ type: SET_NOTIFICATIONS, payload: data.notifications });
            store.dispatch(replace('/dashboard'));
          }
        })
        .catch((e) => {
          console.error(e);
          this.setState({ password: '', passwordInvalid: true, usernameInvalid: false, loading: false });
        })
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form onSubmit={(e) => e.preventDefault()}>
              <Card login className={classes[this.state.cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="rose"
                >
                  <h4 className={classes.cardTitle}>Log in</h4>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    labelText={(this.state.usernameInvalid ? "Invalid Email/Username" : "Email/Username")}
                    id="email"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Email className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      onChange: (event) => {
                        this.setState({ username: event.target.value, usernameInvalid: false });
                      },
                      value: this.state.username,
                      autoComplete: "username"
                    }}
                    error={this.state.usernameInvalid}
                  />
                  <CustomInput
                    labelText={(this.state.passwordInvalid ? "Invalid Password" : "Password")}
                    id="password"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}>
                            lock_outline
                          </Icon>
                        </InputAdornment>
                      ),
                      type: "password",
                      onChange: (event) => {
                        this.setState({ password: event.target.value, passwordInvalid: false });
                      },
                      value: this.state.password,
                      onKeyPress: (e) => {
                        if (e.key === 'Enter') {
                          this.submitLogin();
                        }
                      },
                      autoComplete: "current-password"
                    }}
                    error={this.state.passwordInvalid}
                  />
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                  {
                    this.state.loading ?
                      <div style={{ paddingBottom: 10 }}>
                        <Loading />
                      </div>
                      :
                      [
                        <Button key="reset" component={Link} to="/requestReset" color="rose" simple size="lg" block>
                          <Sync />&nbsp;&nbsp;
                          Reset
                        </Button>,
                        <br key="br" />,
                        <Button key="login" onClick={() => this.submitLogin()} color="rose" size="lg" block>
                          Let's Go
                          &nbsp;&nbsp;<ArrowForward />
                        </Button>
                      ]
                  }
                </CardFooter>
              </Card>
            </form>
          </GridItem>
        </GridContainer>

      </div>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(withGoogleReCaptcha(Login));
